import React from "react"

import { type IconProps } from "./utils"

export default function ArticleIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.9828 29.9043C42.9828 30.4795 42.6315 30.9733 41.9187 31.3857L37.6017 33.8803L36.7922 34.3486C36.0795 34.7559 35.2243 34.9595 34.2265 34.9595C33.2287 34.9595 32.3682 34.7508 31.6504 34.3384L30.7595 33.8243L26.4933 31.3603C25.7755 30.9479 25.4192 30.449 25.4141 29.8737C25.4141 29.6294 25.4751 29.4003 25.6024 29.1865C25.7755 28.8912 26.0656 28.6264 26.478 28.3923L30.9478 25.8112L31.6046 25.4294C32.3122 25.0221 33.1726 24.8134 34.1704 24.8185C35.1682 24.8185 36.0286 25.0271 36.7464 25.4395L37.3726 25.801L41.9035 28.4177C42.2955 28.6417 42.5807 28.8963 42.7588 29.1712C42.9065 29.4003 42.9828 29.6446 42.9828 29.9043Z"
        fill="#F9F9FB"
        stroke="#1E1F24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8332 14.5192L12.6711 11.541C11.9584 11.1286 11.098 10.9199 10.1001 10.9199C9.10232 10.9199 8.24196 11.1235 7.52923 11.5308L2.40785 14.4937C1.69512 14.9061 1.33871 15.3999 1.3438 15.9752C1.3438 16.5505 1.7052 17.0494 2.42302 17.4617L7.58019 20.4399C8.29801 20.8522 9.15328 21.061 10.1562 21.061C11.154 21.0661 12.0093 20.8574 12.7221 20.4501L17.8485 17.4872C18.5612 17.0799 18.9126 16.5861 18.9126 16.0057C18.9075 15.4305 18.5459 14.9316 17.8332 14.5192Z"
        fill="#F9F9FB"
        stroke="#1E1F24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9828 29.8634V29.8736C18.9828 30.4437 18.6265 30.9376 17.924 31.3448L13.6018 33.8394L12.7974 34.3026C12.0847 34.715 11.2294 34.9186 10.2265 34.9186C9.22866 34.9135 8.36824 34.7048 7.65552 34.2925L2.49339 31.3143C1.78066 30.9019 1.41915 30.408 1.41406 29.8277C1.41406 29.2524 1.76538 28.7586 2.4781 28.3463L3.05842 28.0103L7.60471 25.3885C8.31744 24.9761 9.17271 24.7725 10.1705 24.7725C11.1734 24.7776 12.0286 24.9812 12.7464 25.3986L13.3777 25.7652L17.2621 28.0052L17.9036 28.3768C18.2956 28.6008 18.5807 28.8503 18.7588 29.1303C18.9065 29.3543 18.9828 29.5986 18.9828 29.8634Z"
        fill="#1E1F24"
        stroke="#1E1F24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.9476 22.955C30.9476 23.5354 30.5965 24.0292 29.8837 24.4365L24.7571 27.3994C24.0444 27.8067 23.1891 28.0154 22.1913 28.0103C21.1884 28.0103 20.3331 27.8016 19.6153 27.3892L18.7244 26.875L14.4582 24.411C13.7404 23.9987 13.3789 23.4998 13.3789 22.9245C13.3789 22.6801 13.44 22.451 13.5673 22.2372C13.7404 21.942 14.0306 21.6772 14.443 21.443L18.9128 18.8569L19.5644 18.4801C20.2771 18.0729 21.1325 17.8641 22.1354 17.8692C23.1332 17.8692 23.9935 18.078 24.7113 18.4903L29.8684 21.4685C30.5811 21.8809 30.9425 22.3798 30.9476 22.955Z"
        fill="#F9F9FB"
        stroke="#1E1F24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.9397 23.0011V23.0112C54.9397 23.5814 54.5834 24.0752 53.8757 24.4825L48.7492 27.4403C48.0415 27.8527 47.1864 28.0563 46.1835 28.0563C45.1856 28.0512 44.3253 27.8476 43.6075 27.4302L38.4503 24.452C37.7375 24.0396 37.3762 23.5458 37.3711 22.9654C37.3711 22.3902 37.7223 21.8963 38.435 21.484L43.5616 18.5262C44.2743 18.1138 45.1296 17.9102 46.1274 17.9102C47.1303 17.9152 47.9856 18.1189 48.7035 18.5363L53.8604 21.5145C54.5783 21.9269 54.9397 22.4207 54.9397 23.0011Z"
        fill="#1E1F24"
        stroke="#1E1F24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.9397 23.0112V33.1828C54.9448 33.7581 54.5884 34.2518 53.8757 34.6642L48.7492 37.622C48.0415 38.0344 47.1864 38.2381 46.1835 38.2381C45.1856 38.233 44.3253 38.0293 43.6075 37.6119L42.9813 37.2504V29.9042C42.9813 29.6446 42.9049 29.4002 42.7573 29.1712C42.5791 28.8962 42.2939 28.6417 41.9019 28.4177L37.3711 25.801V22.9653C37.3762 23.5457 37.7375 24.0395 38.4503 24.4518L43.6075 27.4301C44.3253 27.8475 45.1856 28.0512 46.1835 28.0562C47.1864 28.0562 48.0415 27.8526 48.7492 27.4402L53.8757 24.4824C54.5834 24.0751 54.9397 23.5813 54.9397 23.0112Z"
        fill="#F9F9FB"
        stroke="#1E1F24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.9828 29.9041V40.0859C42.9828 40.6612 42.6315 41.1549 41.9187 41.5673L36.7922 44.5303C36.0795 44.9375 35.2243 45.1412 34.2265 45.1412C33.2287 45.1412 32.3682 44.9324 31.6504 44.5201L26.4933 41.5419C25.7755 41.1295 25.4192 40.6306 25.4141 40.0554V29.8735C25.4192 30.4488 25.7755 30.9477 26.4933 31.3601L30.7595 33.8241L31.6504 34.3383C32.3682 34.7506 33.2236 34.9594 34.2265 34.9594C35.2294 34.9594 36.0795 34.7557 36.7922 34.3484L37.6017 33.8801L41.9187 31.3855C42.6315 30.9731 42.9828 30.4794 42.9828 29.9041Z"
        fill="#F9F9FB"
        stroke="#1E1F24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.9476 22.9549V25.8109L26.4778 28.392C26.0655 28.6261 25.7753 28.8909 25.6022 29.1861C25.4749 29.4 25.4139 29.629 25.4139 29.8734V37.1992L24.7571 37.581C24.0444 37.9883 23.1891 38.197 22.1913 38.192C21.1884 38.192 20.3331 37.9832 19.6153 37.5709L18.984 37.2043V29.8632C18.984 29.5985 18.9077 29.3541 18.76 29.1301C18.5819 28.8501 18.2968 28.6007 17.9048 28.3767L17.2633 28.005L13.3789 25.765V22.9243C13.3789 23.4996 13.7404 23.9985 14.4582 24.4109L18.7244 26.8749L19.6153 27.389C20.3331 27.8014 21.1884 28.0101 22.1913 28.0101C23.1891 28.0101 24.0444 27.8065 24.7571 27.3992L29.8837 24.4363C30.5965 24.029 30.9476 23.5352 30.9476 22.9549Z"
        fill="#F9F9FB"
        stroke="#1E1F24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9828 29.8735V40.0451C18.9879 40.6204 18.6316 41.1142 17.924 41.5266L12.7974 44.4844C12.0847 44.8968 11.2294 45.1004 10.2265 45.1004C9.22866 45.0953 8.36824 44.8866 7.65552 44.4742L2.49339 41.496C1.78066 41.0837 1.41915 40.5898 1.41406 40.0095V29.8276C1.41915 30.408 1.78066 30.9019 2.49339 31.3142L7.65552 34.2924C8.36824 34.7048 9.22866 34.9135 10.2265 34.9185C11.2294 34.9185 12.0847 34.715 12.7974 34.3026L13.6018 33.8393L17.924 31.3448C18.6265 30.9375 18.9828 30.4437 18.9828 29.8735Z"
        fill="#F9F9FB"
        stroke="#1E1F24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9125 16.0061V18.857L14.4426 21.4432C14.0303 21.6774 13.7401 21.9421 13.567 22.2374C13.4398 22.4512 13.3786 22.6803 13.3786 22.9246V25.7654L12.7474 25.3989C12.0295 24.9814 11.1743 24.7777 10.1714 24.7726C9.17359 24.7726 8.31832 24.9763 7.60559 25.3887L3.05932 28.0105L2.42296 27.6439C1.70514 27.2316 1.34375 26.7327 1.34375 26.1574V15.9756C1.34375 16.5509 1.70514 17.0498 2.42296 17.4621L7.58009 20.4403C8.29791 20.8526 9.15323 21.0614 10.1561 21.0614C11.154 21.0665 12.0092 20.8577 12.722 20.4504L17.8485 17.4875C18.5612 17.0803 18.9125 16.5865 18.9125 16.0061Z"
        fill="#F9F9FB"
        stroke="#1E1F24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
